import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { SOFTLINE_API_DELIVERY_NOTE_DOCUMENT } from '../delivery-note-correction.api';

@Injectable()
export class DeliveryNoteDocumentRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  /** `DELETE …/documents/{id}`, 204: a wrong Korrekturbeleg is deleted and the original corrected again. */
  async remove(id: string): Promise<void> {
    await this.dataAccess.delete<void>({ path: SOFTLINE_API_DELIVERY_NOTE_DOCUMENT, pathParams: { id } });
  }
}
